import { Stack, Text } from '@mantine/core';
import type { TestPlanAnalysis, TestPlanIssue } from '@/types/testPlanAnalysis.ts';

export default function TestPlanAnalysisSummary({
  analysis,
  issues,
}: {
  analysis?: TestPlanAnalysis | null;
  issues?: TestPlanIssue[];
}) {
  const work = analysis?.work_estimate ??
    issues?.find((issue) => issue.details?.work_estimate)?.details?.work_estimate;
  const assertions = analysis?.assertion_planning ?? [];
  if (!work && !assertions.length) return null;
  return (
    <Stack gap={4} role="group" aria-label="Test planning analysis">
      {work && <>
        <Text size="sm">
          Planned work: at least {work.minimum} scheduled executions; budget {work.budget}.
          {work.maximum !== null && work.maximum !== work.minimum &&
            ` Estimated upper bound: ${work.maximum}.`}
        </Text>
        {work.maximum === null && <Text size="sm">Runtime work is not fully known.</Text>}
        {work.uncertainties.map((item, index) => (
          <Text size="xs" key={`${item.step_id}-${index}`}>
            {item.step_id}: {item.reason.replaceAll('_', ' ')}
          </Text>
        ))}
        <Text size="xs" c="dimmed">
          Estimates describe the requested route. Retries and runtime decisions can change the work;
          the runtime limit still applies.
        </Text>
      </>}
      {assertions.filter((item) => item.issue).map((item) => (
        <Text size="sm" key={item.assertion_id}>{item.issue}</Text>
      ))}
    </Stack>
  );
}
